import { formatDate } from "../../../../common/Validations";
// import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
export let colData = [
  {
    name: "Get_ENQUIRY_LIST",
    columns: [
     
     {
      name: "Reference Nr",
      id: "qtnReferenceNr",
      // dropDown: true,
      selector: (row) =>
        `${row?.jobReferenceNr || ""} - ${row?.qtnReferenceNr || ""}`,
      cell: (row) => (
        <>
          <span className="text-bold fw-bold">
            {row.jobReferenceNr}
            {row.qtnReferenceNr}
          </span>
        </>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Type",
      selector: (row) => row?.type,
      id: "type",
      dropDown: true,
      cell: (row) => (
        <>
          <span
            className={` ${
              row.type === "Quotation"
                ? ""
                : row.type === "Job"
                ? ""
                : ""
            }`}
          >
            {row.type}
          </span>
        </>
      ),
      sortable: true,
      width: "140px",
    },
   
    {
      name: "Company",
      selector: (row) => row.clientName,
      id: "clientName",
      dropDown: false,
      cell: (row) => (
        <div>
          {/* <p class="fw-bold">{row.clientName}</p> */}
          <p class="">{row.companyName}</p>
        </div>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Client",
      selector: (row) => row.clientName,
      id: "clientName",
      dropDown: false,
      cell: (row) => (
        <div>
          <p class="">{row.clientName}</p>
        </div>
      ),
      sortable: true,
      width: "180px",
    },

    {
      name: "Building Name",
      selector: (row) => row.buildingName,
      cell: (row) => (
        <div>
          <p className="">{row.buildingName} </p>
        </div>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Sales Officer",
      id: "salesOfficerName",
      dropDown: true,
      selector: (row) => row.salesOfficerName,
      cell: (row) => (
        <div>
          <p className=" ">{row.salesOfficerName} </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },

    {
      name: "Location",
      selector: (row) => row.location,
      id: "location",
      dropDown: false,
      cell: (row) => (
        <div>
          <p className=" ">{row.location} </p>
        </div>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Estimation Date",
      selector: (row) => row.estimationDate,
      id: "estimationDate",
      month: true,
      cell: (row) => (
        <div>
          <p className=" ">{formatDate(row?.estimationDate)}</p>
        </div>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Location",
      selector: (row) => row.location,
      id: "location",
      month: true,
      cell: (row) => (
        <div>
          <p className=" ">{row?.location}</p>
        </div>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Remarks",
      selector: (row) => row.remarks,
      id: "remarks",
      month: true,
      cell: (row) => (
        <div>
          <p className=" ">{row?.remarks}</p>
        </div>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "DocumentNumber",
      selector: (row) => row.documentNumber,
      id: "documentNumber",
      month: true,
      cell: (row) => (
        <div>
          <p className=" ">{row?.documentNumber}</p>
        </div>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Enquiry Nr",
      selector: (row) => row.enquiryNr,
      id: "enquiryNr",
      month: true,
      cell: (row) => (
        <div>
          <p className=" ">{row?.enquiryNr}</p>
        </div>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Created By",
      selector: (row) => row.createdBy,
      id: "enquiryNr",
      month: true,
      cell: (row) => (
        <div>
          <p className=" ">{row?.createdBy}</p>
        </div>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Created Name",
      selector: (row) => row.createdName,
      id: "enquiryNr",
      month: true,
      cell: (row) => (
        <div>
          <p className=" ">{row?.createdName}</p>
        </div>
      ),
      sortable: true,
      width: "150px",
    },
   
    ],
  },
  {
    name: "Get_JOB_LIST",
    columns: [
      {
           name: "Job Reference Nr",
           id: "jobReferenceNr",
           dropDown: true,
           selector: (row) => row?.jobReferenceNr,
           cell: (row) => (
             <>
               <span class="text-bold fw-bold">
                 {row.jobReferenceNr}
               </span>
             </>
           ),
           sortable: true,
           width: "180px",
         },
         {
           name: "Version",
           selector: (row) => row?.version,
           cell: (row) => (
             <>
               <span class="">
                 {row.version}
               </span>
             </>
           ),
           sortable: true,
           width: "120px",
         },
        
         {
           name: "Client",
           selector: (row) => row.companyName,
           id: "companyName",
           dropDown: true,
           cell: (row) => (
             <div>
               <p class="">{row.companyName}</p>
               {/* <p class="fw-bold">{row.clientName}</p> */}
             </div>
           ),
           sortable: true,
           width: "160px",
         },
         {
           name: "Client",
           selector: (row) => row.clientName,
           id: "clientName",
           dropDown: true,
           cell: (row) => (
             <div>
               <p class="">{row.clientName}</p>
               {/* <p class="fw-bold">{row.clientName}</p> */}
             </div>
           ),
           sortable: true,
           width: "160px",
         },
         {
           name: "Building Structure",
           selector: (row) => row.buildingName,
           cell: (row) => (
             <div>
               <p className="">{row.buildingName} </p>
             </div>
           ),
           sortable: true,
           width: "160px",
         },
         {
           name: "Location",
           id: "location",
           dropDown: true,
           selector: (row) => row.location,
           cell: (row) => (
             <div>
               <p className=" ">{row.location} </p>
             </div>
           ),
           sortable: true,
           width: "160px",
         },
         {
           name: "Estimation Date",
           id: "tenestinationDate",
           dropDown: true,
           selector: (row) => row.tenestinationDate,
           cell: (row) => (
             <div>
               <p className=" ">{formatDate(row.tenestinationDate)} </p>
             </div>
           ),
           sortable: true,
           width: "160px",
         },
        
         {
           name: "Building Strucuture",
           id: "buildingName",
           dropDown: true,
           selector: (row) => row.buildingName,
           cell: (row) => (
             <div>
               <p className=" ">{row.buildingName} </p>
             </div>
           ),
           sortable: true,
           width: "160px",
         },
         
         {
           name: "Checker Name",
           id: "checkerName",
           dropDown: true,
           selector: (row) => row.checkerName,
           cell: (row) => (
             <div>
               <p className=" ">{row.checkerName} </p>
             </div>
           ),
           sortable: true,
           width: "160px",
         },
         {
           name: "Remarks",
           id: "remarks",
           dropDown: true,
           selector: (row) => row.remarks,
           cell: (row) => (
             <div>
               <p className=" ">{row.remarks} </p>
             </div>
           ),
           sortable: true,
           width: "160px",
         },
         {
           name: "DocumentNumber",
           id: "documentNumber",
           dropDown: true,
           selector: (row) => row.documentNumber,
           cell: (row) => (
             <div>
               <p className=" ">{row.documentNumber} </p>
             </div>
           ),
           sortable: true,
           width: "160px",
         },
        
         {
           name: "Created By",
           id: "createdBy",
           dropDown: true,
           selector: (row) => row.createdBy,
           cell: (row) => (
             <div>
               <p className=" ">{row.createdBy} </p>
             </div>
           ),
           sortable: true,
           width: "160px",
         },
         {
           name: "Created Name",
           id: "createdName",
           dropDown: true,
           selector: (row) => row.createdName,
           cell: (row) => (
             <div>
               <p className=" ">{row.createdName} </p>
             </div>
           ),
           sortable: true,
           width: "160px",
         },
        
    ],
  },
  {
    name: "Get_QUOTATION_LIST",
    columns: [
      {
            name: "Qtn Reference Nr",
            id: "qtnReferenceNr",
            dropDown: true,
            selector: (row) => row?.qtnReferenceNr,
            cell: (row) => (
              <>
                <span class="text-bold fw-bold ">
                  {row.qtnReferenceNr}
                </span>
              </>
            ),
            sortable: true,
            width: "180px",
          },
          {
            name: "Version",
            selector: (row) => row?.version,
            cell: (row) => (
              <>
                <span class="">
                  {row.version}
                </span>
              </>
            ),
            sortable: true,
            width: "120px",
          },
          
          {
            name: "Estimate",
            selector: (row) => row.estimationNr || row.documentNumber || "--",
            sortable: true,
            cell: (row) => {
              if (row.estimationNr) {
                return (
                  <span className="">
                    {row.estimationNr}
                  </span>
                );
              }
            },
            width: "150px",
          },
          {
            name: "Status",
            selector: (row) => row?.estHeaderStatus,
            cell: (row) => (
              <>
                <span class="">{row.estHeaderStatus}</span>
                {/* <TableStatusField status={row.estHeaderStatus} /> */}
              </>
            ),
            sortable: true,
            width: "180px",
          },
      
          {
            name: "Company",
            selector: (row) => row.companyName,
            id: "companyName",
            dropDown: true,
            cell: (row) => (
              <div>
                <p class="">{row.companyName}</p>
                {/* <p class="fw-bold">{row.clientName}</p> */}
              </div>
            ),
            sortable: true,
            width: "180px",
          },
      
          {
            name: "Client",
            selector: (row) => row.clientName,
            id: "clientName",
            dropDown: true,
            cell: (row) => (
              <div>
                {/* <p class="">{row.clientName}</p> */}
                <p class="">{row.clientName}</p>
              </div>
            ),
            sortable: true,
            width: "180px",
          },
          {
            name: "Designer",
            id: "designerName",
            dropDown: true,
            selector: (row) => row.designerName,
            cell: (row) => (
              <div>
                <p className=" ">{row.designerName} </p>
              </div>
            ),
            sortable: true,
            width: "160px",
          },
          {
            name: "Location",
            id: "location",
            dropDown: true,
            selector: (row) => row.location,
            cell: (row) => (
              <div>
                <p className=" ">{row.location} </p>
              </div>
            ),
            sortable: true,
            width: "160px",
          },
          {
            name: "Estimation Date",
            id: "tenestinationDate",
            dropDown: true,
            selector: (row) => row.tenestinationDate,
            cell: (row) => (
              <div>
                <p className=" ">{formatDate(row.tenestinationDate)} </p>
              </div>
            ),
            sortable: true,
            width: "160px",
          },
          {
            name: "Building Strucuture",
            id: "buildingName",
            dropDown: true,
            selector: (row) => row.buildingName,
            cell: (row) => (
              <div>
                <p className=" ">{row.buildingName} </p>
              </div>
            ),
            sortable: true,
            width: "160px",
          },
          {
            name: "Cheker",
            id: "checkerName",
            dropDown: true,
            selector: (row) => row.checkerName,
            cell: (row) => (
              <div>
                <p className=" ">{row.checkerName} </p>
              </div>
            ),
            sortable: true,
            width: "160px",
          },
          {
            name: "Remarks",
            id: "remarks",
            dropDown: true,
            selector: (row) => row.remarks,
            cell: (row) => (
              <div>
                <p className=" ">{row.remarks} </p>
              </div>
            ),
            sortable: true,
            width: "160px",
          },
          {
            name: "Created By",
            id: "createdBy",
            dropDown: true,
            selector: (row) => row.createdBy,
            cell: (row) => (
              <div>
                <p className=" ">{row.createdBy} </p>
              </div>
            ),
            sortable: true,
            width: "160px",
          },
          {
            name: "Created Name",
            id: "createdName",
            dropDown: true,
            selector: (row) => row.createdName,
            cell: (row) => (
              <div>
                <p className=" ">{row.createdName} </p>
              </div>
            ),
            sortable: true,
            width: "160px",
          },
         
         
    ],
  },
  {
    name: "Get_ESTIMATION_LIST",
    columns:[
  {
        name: "Estimation Nr",
        id: "documentNumber",
        selector: (row) => row?.documentNumber,
        cell: (row) => (
          <>
            
            <span className="fw-bold text-bold">{row?.documentNumber}</span>
          </>
        ),
        width: "120px",
      },
  
      {
        name: "Version",
        id: "version",
        selector: (row) => row?.version,
        cell: (row) => (
          <>
            <span className="fw-bold text-bold">
              {row.version}
            </span>
          </>
        ),
        sortable: true,
        width: "120px",
      },
      {
        name: "Job/Qtn Ref",
        selector: (row) => row?.qtnReferenceNr,
        cell: (row) => {
          const jobRef = row?.jobReferenceNr;
          const qtnRef = row?.qtnReferenceNr;
  
          const displayValue = jobRef || qtnRef || "--";
          const typeLabel = jobRef ? " (Job)" : qtnRef ? " (Qtn)" : "";
          // const textColor = jobRef ? "green" : qtnRef ? "orange" : "";
  
          return (
            <>
              <span className="">
                {displayValue}
              </span>
  
              {typeLabel && (
                <span
                  style={{
                    fontSize: "0.75em",
                    marginLeft: "5px",
                    // color: textColor,
                  }}
                >
                  {typeLabel}
                </span>
              )}
            </>
          );
        },
        sortable: true,
        width: "150px",
      },
      {
        name: "Status",
        selector: (row) => row.headerStatus,
        cell: (row) => {
          return (<>
          <span>{row.headerStatus}</span>
          </>);
        },
        width: "200px",
      },  
      {
        name: "Client",
        selector: (row) => row.clientName,
        id: "clientName",
        dropDown: true,
        cell: (row) => (
          <div>
            {/* <p className="">{row.clientName}</p> */}
            <p className="">{row.clientName}</p>
          </div>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Company",
        selector: (row) => row.companyName,
        id: "companyName",
        dropDown: true,
        cell: (row) => (
          <div>
            <p className="">{row.companyName}</p>
            {/* <p className="fw-bold">{row.clientName}</p> */}
          </div>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Tonnage",
        selector: (row) => row.grandTotalWeight,
        id: "grandTotalWeight",
        dropDown: true,
        cell: (row) => (
          <div>
            <p className="text">
              {(row?.grandTotalWeight
                ? row.grandTotalWeight.toFixed(3)
                : "0.000") + " Mt"}
            </p>
            {/* <p className="fw-bold text-bold">
              {row?.getOverallBuildingArea?.toFixed(3) + " SqFt"}
            </p> */}
          </div>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Area",
        selector: (row) => row.getOverallBuildingArea,
        id: "grandTotalWeight",
        dropDown: true,
        cell: (row) => (
          <div>
            {/* <p className="text">
              {(row?.grandTotalWeight
                ? row.grandTotalWeight.toFixed(3)
                : "0.000") + " Mt"}
            </p> */}
            <p className="">
              {row?.getOverallBuildingArea?.toFixed(3) + " SqFt"}
            </p>
          </div>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Cost",
        selector: (row) => row.grandTotalPrice,
        id: "grandTotalPrice",
        dropDown: true,
        cell: (row) => (
          <div>
            <p className="">
              {row?.grandTotalPrice?.toFixed(3)} INR{" "}
            </p>
          </div>
        ),
        sortable: true,
        width: "160px",
      },
  
      {
        name: "Created By",
        selector: (row) => row.createdBy,
        cell: (row) => (
          <>
            <div>
              <p className="">{row.createdBy}</p>
              <p className="d-block">{row.createdName}</p>
            </div>
          </>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Est Created Date",
        selector: (row) => row.tenestinationDate,
        cell: (row) => (
          <>
            <div>
              <p className="">{formatDate(row.tenestinationDate)}</p>
              {/* <p className="d-block">{row.createdName}</p> */}
            </div>
          </>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Est Start Date",
        selector: (row) => row.estimateStartdat,
        cell: (row) => (
          <>
            <div>
              <p className="">{formatDate(row.estimateStartdat)}</p>
              {/* <p className="d-block">{row.createdName}</p> */}
            </div>
          </>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Est End Date",
        selector: (row) => row.estimateEndDate,
        cell: (row) => (
          <>
            <div>
              <p className="">{formatDate(row.estimateEndDate)}</p>
              {/* <p className="d-block">{row.createdName}</p> */}
            </div>
          </>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Sales Officer",
        selector: (row) => row.salesOfficerName,
        cell: (row) => (
          <>
            <div>
              <p className="">{row.salesOfficerName}</p>
              {/* <p className="d-block">{row.createdName}</p> */}
            </div>
          </>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Building Strucuture",
        selector: (row) => row.buildingTypes,
        cell: (row) => (
          <>
            <div>
              <p className="">{row.buildingTypes}</p>
              {/* <p className="d-block">{row.createdName}</p> */}
            </div>
          </>
        ),
        sortable: true,
        width: "160px",
      },
      // {
      //   name: "Remark",
      //   selector: (row) => row.qtn_Job_Remarks,
      //   cell: (row) => (
      //     <>
      //       <div>
      //         <p className="">{row.qtn_Job_Remarks}</p>
      //         {/* <p className="d-block">{row.createdName}</p> */}
      //       </div>
      //     </>
      //   ),
      //   sortable: true,
      //   width: "160px",
      // },
      {
        name: "Quotation Nr",
        selector: (row) => row.quotationNr,
        cell: (row) => (
          <>
            <div>
              <p className="">{row.quotationNr}</p>
              {/* <p className="d-block">{row.createdName}</p> */}
            </div>
          </>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Job Nr",
        selector: (row) => row.quotationNr,
        cell: (row) => (
          <>
            
            {row?.transactionNr &&
                      !row.transactionNr.startsWith("QU") && (
                        <>
                          <strong>Job Nr:</strong> {row.transactionNr} <br />
                        </>
                      )}
          </>
        ),
        sortable: true,
        width: "160px",
      },
      {
        name: "Created By",
        selector: (row) => row.createdBy,
        cell: (row) => (
          <>
            <div>
              <p className="">{row.createdBy}</p>
              {/* <p className="d-block">{row.createdName}</p> */}
            </div>
          </>
        ),
        sortable: true,
        width: "160px",
      },
      // {
      //   name: "Created Name",
      //   selector: (row) => row.createdName,
      //   cell: (row) => (
      //     <>
      //       <div>
      //         <p className="">{row.createdName}</p>
      //         {/* <p className="d-block">{row.createdName}</p> */}
      //       </div>
      //     </>
      //   ),
      //   sortable: true,
      //   width: "160px",
      // },
  
     
]
  },
  {
    name: "LOADING_ADVICE_REPORT",
    columns: [
      {
        name: "Loading Nr",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-new-status">
              {row.loadingAdviceNr}
            </span>
          </>
        ),
        selector: (row) => row.loadingAdviceNr || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Invoice Date",
        selector: (row) => (
          <>
            <span className="fw-bold text-primary">
              {formatDate(row.createdAt)}
            </span>
          </>
        ),
        sortable: true,
        width: "140px",
      },
      {
        name: "Order Nr",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-new-status">
              {row.orderSchedulingNr}
            </span>
          </>
        ),
        selector: (row) => row.orderSchedulingNr || "--",
        sortable: true,
        width: "130px",
      },

      {
        name: "Company",
        selector: (row) => row.companyCodeDesc || "--",
        cell: (row) => (
          <>
            <span className="fw-bold text-success">{row.companyCodeDesc}</span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Customer",
        selector: (row) => row.customerName || "--",
        cell: (row) => (
          <>
            <span className="fw-bold">{row.customerName}</span>
          </>
        ),
        sortable: true,
        width: "130px",
      },
      {
        name: "Item id",
        selector: (row) => row.local_id,
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.local_id} </p>
            </div>
          </>
        ),
        width: "100px",
        sortable: true,
      },

      {
        name: "Material",
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.materialCode} </p>
              <p className="m-0 p-0">{row.materialDescription} </p>
            </div>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Order Qty Load Confirm ",
        selector: (row) => row.orderQtyLoadConfirm || "--",
        sortable: true,
        width: "150px",
      },

      {
        name: "UOM ",
        selector: (row) => row.uOM || "--",
        width: "100px",
      },
      {
        name: "Unit Price ",
        selector: (row) => row.unitPrice || "--",
        width: "100px",
      },
      {
        name: "Shipping Addr",
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.shippingAddress} </p>
              <p className="m-0 p-0">{row.shippingPostalCode} </p>
            </div>
          </>
        ),
        width: "140px",
      },
      {
        name: "Godown Addr",
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.godownAddress} </p>
            </div>
          </>
        ),
        width: "140px",
      },
      {
        name: "Truck Nr",
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.loadingTruckNo} </p>
            </div>
          </>
        ),
        width: "140px",
      },
      {
        name: "Driver",
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.transporterDriverName} </p>
              <p className="m-0 p-0 pt-1">{row.transporterDriverContact} </p>
            </div>
          </>
        ),
        width: "140px",
      },
    ],
  },

  {
    name: "PR_REPORT",
    columns: [
      {
        name: "Company Code",
        cell: (row) => (
          <>
            <span className="m-0 p-0 pt-1 fw-bold">{row.companyCode}</span>
          </>
        ),
        selector: (row) => row.companyCode || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Pur Org",
        selector: (row) => row.purchasingOrg || "--",
        sortable: true,
        width: "120px",
      },
      {
        name: "Pur Category",
        cell: (row) => (
          <>
            <span className="m-0 p-0 pt-1 fw-bold">{row.purchaseCategory}</span>
          </>
        ),
        selector: (row) => row.purchaseCategory || "--",
        sortable: true,
        width: "130px",
      },
      {
        name: "PR Nr",
        selector: (row) => row.purchaseReqDocumentNr || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-new-status">
              {row.purchaseReqDocumentNr}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "PR Date",
        selector: (row) => row.purchasingDocumentDate || "--",
        sortable: true,
        width: "150px",
      },

      {
        name: "Satus",
        selector: (row) => row.prStatusHeader || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-success-status">
              {row.prStatusHeader}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "PR Item Nr",
        selector: (row) => row.purchasingReqDocumentItemNr || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Material/Service",
        selector: (row) => row.materialCode,
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.materialCode} </p>
              <p className="m-0 p-0">{row.materialDescription} </p>
            </div>
          </>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Material Group ",
        selector: (row) => row.materialGroup || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Quantity ",
        selector: (row) => row.purchaseQuantity || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "UOM ",
        selector: (row) => row.orderUnitOfMeasure || "--",
        width: "100px",
      },
      {
        name: "Unit Price ",
        selector: (row) => row.orderPriceUnit || "--",
        width: "100px",
      },
      {
        name: "Currency",
        selector: (row) => row.currency || "--",
        width: "100px",
      },
      {
        name: "Delivery Date ",
        selector: (row) => row.deliveryDate || "--",
        width: "150px",
      },
      {
        name: "Storage Locn",
        selector: (row) => row.storageLocn || "--",
        width: "150px",
      },
    ],
  },
  {
    name: "ASN_REPORT",
    columns: [
      {
        name: "ASN Nr",
        selector: (row) => row.asnNumber || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-new-status">
              {row.asnNumber}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "ASN Date",
        selector: (row) => row.purchasingDocumentDate || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "ASN Status",
        selector: (row) => row.asnStatusHeader || "--",
        sortable: true,
        width: "150px",
      },

      {
        name: "Pur Doc Nr",
        selector: (row) => row.purchasingDocumentNr || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-success-status">
              {row.purchasingDocumentNr}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Vendor Code",
        selector: (row) => row.vendorCode || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Vendor Name",
        selector: (row) => row.vendorName || "--",
        sortable: true,
        width: "150px",
      },
      // {
      //   name: "Pur Category",
      //   cell: (row) => (
      //     <>
      //       <span className="m-0 p-0 pt-1 fw-bold">{row.purchaseCategory}</span>
      //     </>
      //   ),
      //   selector: (row) => row.purchaseCategory || "--",
      //   sortable: true,
      //   width: "130px",
      // },
      {
        name: "ASN Item Nr",
        selector: (row) => row.asnItemNr || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Material/Service",
        selector: (row) => row.materialCode,
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.materialCode} </p>
              <p className="m-0 p-0">{row.materialDescription} </p>
            </div>
          </>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Material Group ",
        selector: (row) => row.materialGroup || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: " ASN Qty ",
        selector: (row) => row.asnQuantity || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "UOM ",
        selector: (row) => row.orderUnitOfMeasure || "--",
        width: "100px",
      },
      {
        name: "Unit Price ",
        selector: (row) => row.orderPriceUnit || "--",
        width: "100px",
      },
      {
        name: "Currency",
        selector: (row) => row.currency || "--",
        width: "100px",
      },
      {
        name: "Delivery Date ",
        selector: (row) => row.deliveryDate || "--",
        width: "150px",
      },
      {
        name: "Storage Locn",
        selector: (row) => row.storageLocn || "--",
        width: "150px",
      },
    ],
  },
  {
    name: "SO_INVOICE_REPORT",
    columns: [
      {
        name: "INV Nr",
        selector: (row) => row.invoiceNr || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-new-status">
              {row.invoiceNr}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "INV Date",
        selector: (row) => row.invDocumentDate || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Status",
        selector: (row) => row.invoiceStatusHeader || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Vendor Code",
        selector: (row) => row.vendorCode || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Vendor Name",
        selector: (row) => row.vendorName || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Pur Doc Nr",
        selector: (row) => row.purchasingDocumentNr || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-success-status">
              {row.purchasingDocumentNr}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "Pur Item Nr",
        selector: (row) => row.purchasingDocumentItemNr || "--",
        sortable: true,
        width: "150px",
      },
      // {
      //   name: "Pur Category",
      //   cell: (row) => (
      //     <>
      //       <span className="m-0 p-0 pt-1 fw-bold">{row.purchaseCategory}</span>
      //     </>
      //   ),
      //   selector: (row) => row.purchaseCategory || "--",
      //   sortable: true,
      //   width: "130px",
      // },
      {
        name: "INV Item Nr",
        selector: (row) => row.invoiceItemNr || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Material/Service",
        selector: (row) => row.materialCode,
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.materialCode} </p>
              <p className="m-0 p-0">{row.materialDescription} </p>
            </div>
          </>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Material Group ",
        selector: (row) => row.materialGroup || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: " INV Qty ",
        selector: (row) => row.invoiceQuantity || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "UOM ",
        selector: (row) => row.orderUnitOfMeasure || "--",
        width: "100px",
      },
      {
        name: "Unit Price ",
        selector: (row) => row.orderPriceUnit || "--",
        width: "100px",
      },
      {
        name: "Currency",
        selector: (row) => row.currency || "--",
        width: "100px",
      },
      {
        name: "Delivery Date ",
        selector: (row) => row.deliveryDate || "--",
        width: "150px",
      },
      {
        name: "Storage Locn",
        selector: (row) => row.storageLocn || "--",
        width: "150px",
      },
    ],
  },
  {
    name: "GRN_REPORT",
    columns: [
      {
        name: "GRN Nr",
        selector: (row) => row.grnNr || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-new-status">
              {row.grnNr}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "GRN Date",
        selector: (row) => row.grnDocumentDate || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Status",
        selector: (row) => row.grnStatusHeader || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Vendor Code",
        selector: (row) => row.vendorCode || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Vendor Name",
        selector: (row) => row.vendorName || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Pur Doc Nr",
        selector: (row) => row.purchasingDocumentNr || "--",
        cell: (row) => (
          <>
            <span className="bg-table-status bg-table-success-status">
              {row.purchasingDocumentNr}
            </span>
          </>
        ),
        sortable: true,
        width: "150px",
      },
      {
        name: "PO Item Nr",
        selector: (row) => row.purchasingDocumentItemNr || "--",
        sortable: true,
        width: "150px",
      },

      // {
      //   name: "Pur Category",
      //   cell: (row) => (
      //     <>
      //       <span className="m-0 p-0 pt-1 fw-bold">{row.purchaseCategory}</span>
      //     </>
      //   ),
      //   selector: (row) => row.purchaseCategory || "--",
      //   sortable: true,
      //   width: "130px",
      // },
      {
        name: "GRN Item Nr",
        selector: (row) => row.grnItemNr || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "Material/Service",
        selector: (row) => row.materialCode,
        cell: (row) => (
          <>
            <div>
              <p className="m-0 p-0 pt-1">{row.materialCode} </p>
              <p className="m-0 p-0">{row.materialDescription} </p>
            </div>
          </>
        ),
        width: "180px",
        sortable: true,
      },
      {
        name: "Material Group ",
        selector: (row) => row.materialGroup || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: " GRN Qty ",
        selector: (row) => row.grnQuantity || "--",
        sortable: true,
        width: "150px",
      },
      {
        name: "UOM ",
        selector: (row) => row.orderUnitOfMeasure || "--",
        width: "100px",
      },

      {
        name: "Delivery Date ",
        selector: (row) => row.deliveryDate || "--",
        width: "150px",
      },
      {
        name: "Plant",
        selector: (row) => row.plant || "--",
        width: "150px",
      },
      {
        name: "Storage Locn",
        selector: (row) => row.storageLocn || "--",
        width: "150px",
      },
      {
        name: "Mov Type",
        selector: (row) => row.movementType || "--",
        width: "150px",
      },
    ],
  },
];
